import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarningIcon } from '../../icons';
import './ErrorStep.scss';
export const ErrorStep = ({ onRetry }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "error-step" },
        React.createElement(WarningIcon, { width: 64, height: 64, fill: "#F83D49" }),
        React.createElement("h2", { className: "error-step__title" }, t('error-step.title')),
        React.createElement("p", { className: "error-step__description" }, t('error-step.description')),
        React.createElement("button", { className: "error-step__button", onClick: onRetry }, t('error-step.retry'))));
};
//# sourceMappingURL=ErrorStep.js.map